import React from 'react';
import RelevantPublications from './relevant-publications/relevant-publications';
import { trimArray, renderAsHtml } from '../../../app-actions';
import { RELEVANT_ARTICLE_COUNT } from '../../../app-constants';
import OrderedList from '../../ordered-list';

const RecommendedProductContent = (props) => {
  const {
    productData: {
      recommendedProductBenefitsDetail,
      recommendedProductBenefitsSummary,
      recommendedProductOpportunities,
      recommendedProductChallenges,
      relatedArticles,
    },
    authorableContent: {
      heading,
      subHeading,
      opportunities,
      challenges,
      relevantPublications,
    },
  } = props;
  const recommendedProductBenefitsDetailAsHtml = renderAsHtml(recommendedProductBenefitsDetail);
  const recommendedProductBenefitsSummaryAsHtml = renderAsHtml(recommendedProductBenefitsSummary);
  const relevantArticlesTrimmed = trimArray(relatedArticles, RELEVANT_ARTICLE_COUNT);
  const hasExtraBenefits = (recommendedProductOpportunities && recommendedProductOpportunities.length > 0)
    || (recommendedProductChallenges && recommendedProductChallenges.length > 0);
  return (
    <div className="product-content">
      <div className="row">
        <div className="col benefits-detail">
          <h2 id="benefit-heading">{heading}</h2>
          <p className="text-muted">{subHeading}</p>
          <p>{recommendedProductBenefitsSummaryAsHtml}</p>
          <p id="benefit-detail-heading" className="text-muted">Benefit details</p>
          <p className="benefits-detail-text">{recommendedProductBenefitsDetailAsHtml}</p>
        </div>
      </div>
      <div className="row">
        {hasExtraBenefits ?
          <div className="col-sm-5">
            <OrderedList heading={opportunities} listData={recommendedProductOpportunities} />
            <OrderedList heading={challenges} listData={recommendedProductChallenges} />
          </div>
          : ''
        }
        <div className={`${hasExtraBenefits ? 'col-sm-6 col-offset-1' : 'col'} product-publications`}>
          {relatedArticles.length > 0 && <h2>{relevantPublications}</h2>}
          <RelevantPublications
            relevantArticles={relevantArticlesTrimmed}
            minimalHeroClass={hasExtraBenefits ? 'col' : 'col-sm-6'}
          />
        </div>
      </div>
    </div>
  );
};

export default RecommendedProductContent;
